import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  TextField,
  Box,
  Grid,
  Typography,
  Button,
  FormGroup,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import InputAdornment from "@mui/material/InputAdornment";
import { SearchOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";
import "../../pages/styles/RuleEnrollment.css";

function ViewRulesDetailDialog({
  openDetail,
  handleClose,
  getRulDef,
  setGetRulDef,
}) {
  useEffect(() => {
    setGetRulDef(getRulDef);
    console.log("detail page");
    console.log(getRulDef);
  }, []);

  return (
    <Dialog
      open={openDetail}
      onClose={handleClose}
      className="largeModalWrapper"
    >
      <DialogTitle variant="h6" onClose={handleClose} className="dialog-title">
        {getRulDef.rule_title}
        {handleClose ? <CloseIcon onClick={handleClose} /> : null}
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2">
          {getRulDef.rule_description}
        </Typography>
        <Box>
          <Divider className="divider" />
          <Typography variant="h6">Input</Typography>
          {getRulDef.rules_input
            ? getRulDef.rules_input.map((val, i) => (
                <>
                  <Box>
                    {getRulDef.rules_relation
                      ? getRulDef.rules_relation.map((val2, i2) => (
                          <>
                            {i == 0 ? (
                              ""
                            ) : (
                              <div className="text-center">
                                {val2}
                              </div>
                            )}
                          </>
                        ))
                      : ""}
                  </Box>
                  <Grid container spacing={0} className="viewSmallBoxContainer">
                    <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                      <Box className="viewSmallBox">
                        <Typography variant="h6">
                          <small>Source</small>
                          {val.source1_name}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                      <Box className="viewSmallBox">
                        <Typography variant="h6">
                          <small>Attribute</small>
                          {val.attribute1_name}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
                      <Box className="viewSmallBox">
                        <Typography variant="h6">
                          <small>Operation</small>
                          {val.operator}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                      <Box className="viewSmallBox">
                        <Typography variant="h6">
                          <small>Source</small>
                          {val.source2_name}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                      <Box className="viewSmallBox">
                        <Typography variant="h6">
                          <small>Attribute</small>
                          {val.attribute2_name}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </>
              ))
            : ""}
        </Box>
        <Box>
          <Divider className="divider" />
          <Typography variant="h6">Output</Typography>
          {getRulDef.rules_output
            ? getRulDef.rules_output.map((val, i) => (
                <>
                  <Grid container spacing={0} className="viewSmallBoxContainer">
                    <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                      <Box className="viewSmallBox">
                        <Typography variant="h6">
                          <small>Type</small>
                          {val.rules_output_type}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                      <Box className="viewSmallBox">
                        <Typography variant="h6">
                          <small>Key</small>
                          {val.rules_output_key}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                      <Box className="viewSmallBox">
                        <Typography variant="h6">
                          <small>Message</small>
                          {val.rules_output_value}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </>
              ))
            : ""}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ViewRulesDetailDialog;
